'use strict';


const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    Loading = require('components/Commons/Loading/Loading'),
    NavigationUtils = require('utils/NavigationUtils'),
    ContentUtils = require('utils/ContentUtils'),
    NumberUtils = require('utils/NumberUtils'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Authentication = require('services/Security').Authentication,
    InventoryStore = require('stores/InventoryStore'),
    get = require('lodash/object').get,
    {filter, map} = require('lodash/collection'),
    {Navigation} = require('react-router'),
    ga = require('react-ga');

let CustomerItemAdmin = React.createClass({displayName: "CustomerItemAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            selectedCustomer: null,
            name: NavigationUtils.getQueryParam('name'),
            customerId: NavigationUtils.getPathParam('customers')
        };
    },

    componentDidMount() {
        this.fetchCustomer();
        ga.pageview('/customer-items-admin');
    },

    fetchCustomer() {
        const self = this;
        const customerId = NavigationUtils.getPathParam('customers');
        InventoryStore.fetchFinishItems(function (items) {
            InventoryStore.fetchCustomerItems(customerId, function (customerItems) {
                self.setState({
                    customerItems: self._decoratorVendorItems(ContentUtils.filterEnableByAttribute(customerItems, ['item.isEnable', 'enable'])),
                    items: ContentUtils.filterEnable(items)
                });
            });
        });
    },

    backToCustomer() {
        this.transitionTo('/customers');
    },

    _decoratorVendorItems(vendorItems) {
        return map(vendorItems, vendorItem => {
            vendorItem.salePriceDisplay = NumberUtils.formatCurrency(vendorItem.salePrice, 4);
            return vendorItem;
        });
    },

    onDeleteCustomerItem(customerItemId, onSuccess, onFailure) {
        CustomDialog.showWarningConfirmation(t('warning'), t('customer_item_admin_confirm_delete'), () => {
            InventoryStore.deleteCustomerItems(NavigationUtils.getPathParam('customers'), customerItemId, onSuccess, onFailure);
        });
    },

    onChangeCustomerItem(customerItem, onSuccess, onFailure) {
        customerItem.customerId = NavigationUtils.getPathParam('customers');
        customerItem.itemId = customerItem.itemId;
        InventoryStore.changeCustomerItem(NavigationUtils.getPathParam('customers'), customerItem, onSuccess, onFailure);
    },

    onAddCustomerItem(customerItem, onSuccess, onFailure) {
        customerItem.customerId = NavigationUtils.getPathParam('customers');
        customerItem.itemId = customerItem.itemId;
        InventoryStore.addCustomerItem(NavigationUtils.getPathParam('customers'), customerItem, onSuccess, onFailure);
    },

    getBreadcrumbLinks() {
        return [
            {link: 'customers', displayName: t('custumer_admin_customers')},
            {displayName: get(this.state, 'name')}
        ];
    },

    _amountValidation(inputValue) {
        if (ContentUtils.isEmptyText(inputValue)) {
            return '';
        }

        let result = NumberUtils.isNumber(inputValue)
            ? ''
            : t('customer_item_admin_amount_must_number');
        const isNumber = result === '';

        if (isNumber) {
            return NumberUtils.isGreaterOrEquals(inputValue, 0) ? ''
                : t('sales_items_could_not_negative');
        }
    },

    _goToAddress() {
        const customerId = NavigationUtils.getPathParam('customers');
        this.transitionTo(
          '/customers/:customerId/addresses',
          {
              customerId
          },
          {
              name: get(this.state, 'name')
          }
        );
    },

    _goToContacts() {
        const customerId = NavigationUtils.getPathParam('customers');
        this.transitionTo(
          '/customers/:customerId/contacts',
          {
              customerId
          },
          {
              name: get(this.state, 'name')
          }
        );
    },

    render() {
        let {customerItems, selectedItem} = this.state;
        if (!customerItems) {
            return (React.createElement(Loading, null));
        } else {
            const messages = {
                changeSuccessMessage: t('customer_item_admin_change_success_message'),
                changeFailureMessage: t('customer_item_admin_change_failure_message'),
                deleteSuccessMessage: t('customer_item_admin_delete_success_message'),
                addSuccessMessage: t('customer_item_admin_add_success_message'),
                addFailureMessage: t('customer_item_admin_add_failure_message')
            };
            const {items} = this.state;

            const additionalButtons = [
                {
                    type: 'CHANGE',
                    permission: 'SHOW',
                    el: React.createElement(FormGroupButton, {
                        label: t('back'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick: this.backToCustomer}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'SHOW',
                    el: React.createElement(FormGroupButton, {
                        label: t('back'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick: this.backToCustomer}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'SHOW',
                    el: (
                      React.createElement(FormGroupButton, {
                        label: t('customer_set_address'), 
                        icon: "subdirectory_arrow_right", 
                        type: "icon", 
                        onClick: this._goToAddress.bind(this)}
                      )
                    )
                },
                {
                    type: 'NEW',
                    permission: 'SHOW',
                    el: (
                      React.createElement(FormGroupButton, {
                        label: t('customer_address_set_contacts'), 
                        icon: "subdirectory_arrow_right", 
                        type: "icon", 
                        onClick: this._goToContacts.bind(this)}
                      )
                    )
                }
            ];

            let contextHolder = this.getContextHolderInstance();

            const formFieldsEl = [

                React.createElement(FormGroupTextFieldSuggested, {
                    operationsHolder: contextHolder, 
                    items: items, 
                    readerAttribute: "description", 
                    readerAttributeValue: "id", 
                    writerAttribute: "itemId", 
                    itemsDisabled: filterItemsAlreadyInUse(
                        items,
                        customerItems
                    ), 
                    customErrorNonMatch: t('customer_item_admin_item_error_non_match'), 
                    name: t('customer_item_admin_label_item'), 
                    label: t('customer_item_admin_label_item'), 
                    value: get(selectedItem, 'item'), 
                    onChange: this.onChangeSelectedItem, 
                    onEnter: this.__onEnterPress}
                ),

                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "salePrice", 
                    name: t('customer_item_admin_label_price'), 
                    value: selectedItem, 
                    isRelaxedText: true, 
                    label: t('customer_item_admin_label_price'), 
                    isDecimalFormat: true, 
                    additionalValidation: this._amountValidation, 
                    onEnter: this.__onEnterPress}
                )
            ];

            return (
                React.createElement("div", {className: "brewhouse-view"}, 
                    React.createElement(AdminScaffolding, {
                        moduleName: "ADMIN_CUSTOMER_PRICE", 
                        title: t('customer_item_admin_title_item_customer_price'), 
                        messages: messages, 
                        contextHolder: contextHolder, 
                        value: selectedItem, 
                        fetchItems: this.fetchCustomer, 
                        headerFields: formFieldsEl, 
                        onAdd: this.onAddCustomerItem, 
                        onChange: this.onChangeCustomerItem, 
                        onCancel: this.__onCancel, 
                        onDelete: this.onDeleteCustomerItem, 
                        additionalButtons: additionalButtons, 
                        breadcrumb: this.getBreadcrumbLinks(), 
                        addEnterKeyDown: this.__addEnterKeyDown
                    }, 

                        React.createElement(AdminScaffoldingTable, {
                            onRowSelection: this.__onRowSelection, 
                            value: selectedItem, 
                            sortByColumn: ['name'], 
                            filteredColumns: ['item.description', 'salePriceDisplay'], 
                            columnNames: [
                                t('customer_item_admin_label_item'),
                                t('customer_item_admin_label_price')
                            ], 
                            displayAttributes: ['item.description', 'salePriceDisplay']
                        }, 
                            customerItems
                        )
                    )
                )
            );
        }
    }
});

function filterItemsAlreadyInUse(items, selectedItems) {
    const itemIdsAlreadyInUse =
        map(selectedItems, selectedItem => get(selectedItem, 'item.id')) || [];
    const itemsFiltered = filter(items, item =>
        itemIdsAlreadyInUse.includes(get(item, 'id'))
    );
    const itemsMarked = map(itemsFiltered, item => {
        item.isDisabled = true;
        return item;
    });

    return itemsMarked;
}

module.exports = CustomerItemAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/CustomerAdmin/CustomerItemAdmin.js
 **/